import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, get } from 'lodash';
import {
  ServiceProvidersList,
} from './components';

// (todo) revisit once data structure is set for how providers are going to be passed in
const createProviderLists = (needs, addToSelectedProviders) => needs.map((need) => (
  <ServiceProvidersList
    key={get(need, 'service_type.name', '')}
    providers={get(need, 'groups', [])}
    addToSelectedProviders={addToSelectedProviders}
    header={get(need, 'service_type.name', '')}
  />
));

const ServiceProviders = ({ getSelectedProviders, needs }) => {
  const [selectedProviders, setSelectedProviders] = useState([]);

  const addToSelectedProviders = (key, providerIds) => {
    const updatedSelectedProviders = [
      ...selectedProviders.filter((item) => item.key !== key),
      ...(isEmpty(providerIds) ? [] : [{ key, providerIds }]),
    ];

    setSelectedProviders(updatedSelectedProviders);
    getSelectedProviders(updatedSelectedProviders);
  };

  if (isEmpty(needs)) {
    return null;
  }

  const providerLists = createProviderLists(needs, addToSelectedProviders);

  return (
    <div className="service-providers">
      {providerLists}
    </div>
  );
};

ServiceProviders.propTypes = {
  getSelectedProviders: PropTypes.func,
  needs: PropTypes.array,
};

ServiceProviders.defaultProps = {
  getSelectedProviders: () => {},
  needs: [],
};

export default ServiceProviders;
